import React, { useState, useEffect } from "react";
import "./ListOwners.css";
import AdminHeader from "../../../Component/AdminHeader/AdminHeader";
import { getOwners, getActiveOwners, getInactiveOwners } from "./Service";
import { useNavigate } from "react-router-dom";

export default function OwnersList() {
  const [owners, setOwners] = useState([]);
  const [activeBtn] = useState("all");
  const [loading, setLoading] = useState(true);

  const limit = 10;
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");

  const navigate = useNavigate();

  const fetchOwners = async (type, currentPage) => {
    setLoading(true);
    const offset = (currentPage - 1) * limit;

    let response;

    if (type === "active") {
      response = await getActiveOwners(offset, limit);
    } else if (type === "inactive") {
      response = await getInactiveOwners(offset, limit);
    } else {
      response = await getOwners(offset, limit);
    }

    const ownersList = response?.data || response || [];
    const total = response?.total || ownersList.length;

    setOwners(Array.isArray(ownersList) ? ownersList : []);
    setTotalCount(total);
    setLoading(false);
  };

  useEffect(() => {
    fetchOwners(activeBtn, page);
  }, [activeBtn, page]);

  const resetFilters = () => {
    setSearch("");
    setStatus("");
  };

  const filteredOwners = owners.filter((o) => {
    const s = search.toLowerCase();
    return (
      (search === "" ||
        o.owner_name?.toLowerCase().includes(s) ||
        o.email?.toLowerCase().includes(s) ||
        o.company_name?.toLowerCase().includes(s)) &&
      (status === "" ||
        (status === "Active" && o.is_active) ||
        (status === "Inactive" && !o.is_active))
    );
  });

  const totalPages = Math.ceil(totalCount / limit);
  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, totalCount);

  return (
    <>
      <AdminHeader />

      <div className="owners-page">
        <div className="owners-header-row">
          <h1>Owners List</h1>

          <button
            className="create-owner-btn"
            onClick={() => navigate("/create-owner")}
          >
            + Create Owner
          </button>
        </div>

        {/* Filters */}
        <div className="filters">
          <input
            type="text"
            className="search-box"
            placeholder="Search by name, email or company..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="filter-dropdown"
          >
            <option value="">Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>

          <button className="reset-btn" onClick={resetFilters}>
            Reset
          </button>
        </div>

        {/* TABLE */}
        {loading ? (
          <div className="loading-text">Loading...</div>
        ) : (
          <div className="owners-table-wrapper">
            <div className="table-scroll">
              <table className="owners-table">
                <thead>
                  <tr>
                    <th>Owner Name</th>
                    <th>Company</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Status</th>
                    <th>Actions</th> {/* ✅ NEW */}
                  </tr>
                </thead>

                <tbody>
                  {filteredOwners.length > 0 ? (
                    filteredOwners.map((o, i) => (
                      <tr key={i}>
                        <td>{o.owner_name}</td>
                        <td>{o.company_name}</td>
                        <td>{o.email}</td>
                        <td>{o.phone_number}</td>

                        <td>
                          <span
                            className={`status-badge ${
                              o.is_active ? "active-badge" : "inactive-badge"
                            }`}
                          >
                            {o.is_active ? "Active" : "Inactive"}
                          </span>
                        </td>

                        <td>
                          <button
                            className="view-sales-btn"
                            onClick={() =>
                              navigate(`/sales-report/${o.id}`)
                            }
                          >
                            View Sales
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center", padding: 20 }}>
                        No results found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Pagination */}
        <div className="pagination-row">
          <span>Rows per page: {limit}</span>

          <div className="pagination-controls">
            <button
              className="page-btn"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              {"<"}
            </button>

            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                className={`page-btn ${page === i + 1 ? "active" : ""}`}
                onClick={() => setPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="page-btn"
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              {">"}
            </button>

            <span className="range-text">
              {start} – {end} of {totalCount}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}